/* Geolocalizzazione delle coordinate dell'utente nella barra di ricerca del calcolo percorso */

import { useLeaflet } from "react-leaflet";
import _ from 'lodash';
import {selectNewPosition} from '../../redux'
import "leaflet.locatecontrol";
import { connect } from "react-redux";
import L from "leaflet";

const LocalizzazioneInBarra = (props) => {
    const { map } = useLeaflet()


    function getPosition(ev){
        props.position(ev.latlng)
        //map.flyTo([ev.latlng.lat, ev.latlng.lng],14);
    }

    map.on('locationfound', function(ev){
        if(!_.isEqual(props.positions.position,ev.latlng)){getPosition(ev)}
        
    });
    return null;
};

const mapStateToProps = state => {
    return {
        positions: state.position
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        position: (position) => dispatch(selectNewPosition(position))
    }
  }

export default connect(mapStateToProps,mapDispatchToProps) (LocalizzazioneInBarra);